import { render } from "./AddRPRDialog.vue?vue&type=template&id=7508e180&scoped=true"
import script from "./AddRPRDialog.vue?vue&type=script&lang=js"
export * from "./AddRPRDialog.vue?vue&type=script&lang=js"

import "./AddRPRDialog.vue?vue&type=style&index=0&id=7508e180&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7508e180"]])

export default __exports__